<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon flat-color"
    data-name="Flat Color"
    viewBox="0 0 24 24"
  >
    <path
      d="m21.71 11.29-9-9a1 1 0 0 0-1.42 0l-9 9a1 1 0 0 0 1.42 1.42l.29-.3v7.89A1.77 1.77 0 0 0 5.83 22H8.5a1 1 0 0 0 1-1v-4.9a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1V21a1 1 0 0 0 1 1h2.67A1.77 1.77 0 0 0 20 20.3v-7.89l.29.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42Z"
    />
  </svg>
</template>